import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M19.794 5.413c.86.231 1.54.911 1.77 1.77.424 1.566.436 4.812.436 4.812s0 3.259-.423 4.811c-.231.86-.91 1.54-1.77 1.77-1.553.424-7.801.424-7.801.424s-6.248 0-7.8-.423c-.86-.231-1.54-.911-1.77-1.77-.424-1.566-.424-4.812-.424-4.812s0-3.246.41-4.798c.231-.86.911-1.54 1.77-1.77 1.553-.424 7.801-.437 7.801-.437s6.248 0 7.8.423m-4.608 6.582-5.183 3.002V8.993z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }